import { jsx as _jsx } from "react/jsx-runtime";
import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';

const CompanySizeView = () => {
  const options = DataOptions[Data.CompanySize];
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    options: options,
    shouldDisableAutofocus: true
  });
};

export default CompanySizeView;